import { Table } from "antd";
import styled from "styled-components";
import { MediaProjectListItem } from "pages/media/types";

export const StyledExperiencesTable = styled(Table<MediaProjectListItem>)`
  border: none;
  box-shadow: ${({ theme }) => theme.boxShadowTertiary};

  .ant-table-container,
  .ant-table-container table > thead > tr:first-child > *:first-child,
  .ant-table-container table > thead > tr:first-child > *:last-child,
  .ant-table-container table > tbody > tr:last-child > *:first-child,
  .ant-table-container table > tbody > tr:last-child > *:last-child {
    border-radius: 0 !important;
  }

  .ant-table-column-sort:not(.ant-table-cell-row-hover) {
    background: transparent !important;
  }
  .ant-table-tbody {
    background-color: ${({ theme }) => theme.colorWhite};
  }
  .ant-table-thead {
    th {
      background-color: #fafafa !important;
    }
  }
  .ant-table-tbody,
  .ant-table-thead {
    td:first-child,
    th:first-child {
      padding-left: 25px !important;
    }
    td:last-child {
      padding-right: 25px !important;
    }
  }
`;
